module.exports = __webpack_public_path__ + "img/en_badge_google.db9b21a1.png";